// Dynamically import all content components from 'component-library' (including subfolders)
const contentComponents = require.context('../components/component-library', true, /\.vue$/);

// Dynamically import all UI components from the 'ui' directory (no subfolders)
const uiComponents = require.context('../components/ui', false, /\.vue$/);

// Function to collect components from a context and add them to the repository
const registerComponents = (context, repository) => {
    context.keys().forEach(fileName => {
        // get the default export for each file
        const componentConfig = context(fileName);
        // extract the component name from the file name
        // Component name MUST be the same as the filename
        const componentName = fileName.split('/').pop().replace(/\.\w+$/, '');

        // Check if the component already exists (DUPLICATE FILENAMES)
        if (repository[componentName]) {
            console.warn(`Component name conflict: "${componentName}" already exists. Skipping "${fileName}"`);
        } else {
            // Add the component to the repository object with its name as the key
            repository[componentName] = componentConfig.default || componentConfig;
        }
    });
};

// Library of globally registered components
const componentsRepository = {};

// Register all content components
registerComponents(contentComponents, componentsRepository);
// Register all ui components
registerComponents(uiComponents, componentsRepository);

const repo = {
    // Register components globally
    setup(app) {
        Object.keys(componentsRepository).forEach(name => {
            app.component(name, componentsRepository[name]);
        });
    },

    // Check if a component has been registered
    has(componentName) {
        return componentName in componentsRepository;
    }
};

export default repo;
